import type { Message } from '@oneToOne/shared/components/chat/types'

export const AGENT_AGORA_TRACK_PLAYER_ID = 'agent-agora-track-player'
export const LIVE_HELPER_ELEMENT_ID = 'fw-live-helper'
export const AGENT_STATUS_ELEMENT_ID = 'fw-agent-status'
export const WS_PATH = '/oto/websocket'
export const ASPECT_RATIO_PORTRAIT = 9 / 16
export const ASPECT_RATIO_LANDSCAPE = 16 / 9
export const ON_CALL_FULLSCREEN_CHAT_WIDTH = 360

// In order to grow and shrink the chat area with a transition,
// the parents containers need to know the height of the chat area.
// Without this the animation will not work.
export const CHAT_HEADER_HEIGHT = {
  videoContainer: 240,
}

export const CHAT_CUSTOMER_VIDEO_HEIGHT = {
  landscape: {
    default: '50px',
    expanded: '80px',
  },
  portrait: {
    default: '80px',
    expanded: '114px',
  },
}

export const Z_INDEX = {
  FULL_SCREEN_PREVIEW: 2147483647, // Has to be higher than BASE_WIDGET
}

// React Transition Group Classnames
export const TRANSITION_CLASSNAMES = {
  SCROLL_TO_BOTTOM_BUTTON: 'scroll-to-bottom-button',
  SYSTEM_ERROR_NOTIFICATION: 'system-error-notification',
  VIDEO_CONTROLS_BUTTON_ROW: 'video-controls-button-row',
} as const

// SHARED TYPING MESSAGE
// This hard-coded string needs a unique key (from other messages)
// in order for React Transition Group to deal with it properly
export const TYPING_MESSAGE = {
  type: 'typing_indicator',
  key: 'unique_typing_indicator_key',
} as unknown as Message

export const TRANSFERRING_MESSAGE_REF = 'transferring_message_ref'

// To prevent overloading the server with typing indicator messages, we throttle
// the sending of WS (WebSocket) messages. The throttle duration is set to be 1 second
// shorter than the dismiss timeout. This ensures that the typing indicator remains
// active for the same duration as the dismiss timeout, with an extra second
// accounted for potential race conditions and variations in network speed.
export const DEFAULT_DISMISS_TYPING_INDICATOR_TIMEOUT = 5000
export const DEFAULT_TYPING_INDICATOR_THROTTLE_DELAY =
  DEFAULT_DISMISS_TYPING_INDICATOR_TIMEOUT - 1000

export const DEFAULT_AVATAR_SRC =
  'https://cdn4.fireworktv.com/medias/2023/8/16/1692227197-yshvelbx/400_400/mikoto-misaka.jpg'

export const DEFAULT_HORIZONTAL_ATTACHMENT_SRC =
  'https://cdn4.fireworktv.com/medias/2023/12/18/1702915287-ypvdsbut/original/frieren-group-celebrating.jpg'

export const DEFAULT_VERTICAL_ATTACHMENT_SRC =
  'https://cdn4.fireworktv.com/medias/2023/12/18/1702915899-ribcensx/original/gojo.jpg'
